import type { LayoutRect, LayoutSnapshotV1 } from './nativeLayout';

/** A native vertical-bar trait is required. Browser widths and device names never opt in. */
export function verticalChromeLayout(layout: LayoutSnapshotV1 | null, nativeIOS: boolean) {
  if (!nativeIOS || !layout?.capabilities.reservedRegions || layout.verticalBarEdge === 'none') return null;
  const edge = layout.verticalBarEdge;
  const width = Math.min(layout.bounds.width, Math.max(64, layout.safeInsets[edge]));
  const lane: LayoutRect = {
    x: edge === 'right' ? layout.bounds.width - width : 0,
    y: layout.safeInsets.top,
    width,
    height: Math.max(0, layout.bounds.height - layout.safeInsets.top - layout.safeInsets.bottom),
  };
  let segments = [{ top: lane.y, bottom: lane.y + lane.height }];
  const obstacles = [...layout.reservedRegions.filter(r => r.active).map(r => ({
    ...r.rect,
    width: r.kind === 'division' ? Math.max(1, r.rect.width) : r.rect.width,
    height: r.kind === 'division' ? Math.max(1, r.rect.height) : r.rect.height,
  })), ...layout.keyboardOcclusions];
  if (!layout.keyboardOcclusions.length && layout.keyboardInset > 0) obstacles.push({
    x: 0, y: layout.bounds.height - layout.keyboardInset,
    width: layout.bounds.width, height: layout.keyboardInset,
  });
  for (const r of obstacles) {
    if (r.x + r.width <= lane.x || r.x >= lane.x + lane.width || r.width <= 0 || r.height <= 0) continue;
    segments = segments.flatMap(s => r.y >= s.bottom || r.y + r.height <= s.top ? [s] : [
      { top: s.top, bottom: Math.min(s.bottom, r.y) },
      { top: Math.max(s.top, r.y + r.height), bottom: s.bottom },
    ].filter(s => s.bottom > s.top));
  }
  const segment = segments.sort((a, b) => (b.bottom - b.top) - (a.bottom - a.top))[0];
  if (!segment || segment.bottom - segment.top < 64) return null;
  return { edge, width, rect: { ...lane, y: segment.top, height: segment.bottom - segment.top } };
}
